/* eslint react/display-name: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Gravatar from '_views/gravatar';
import LineItem from '_views/lineItem';

const UserInfo = ({ user }) => {
  if (!user) return null;

  return (
    <React.Fragment>
      <Gravatar gravatar={user.gravatar} size={60} style={{ marginBottom: '16px' }} />
      <LineItem label='ID' text={user._id} />
      <LineItem label='Name' text={user.full_name} />
      <LineItem label='Display Name' text={user.displayname} />
      <LineItem label='Email' text={user.email} />
      <LineItem label='Created on' text={moment(user.created_on).format('YYYY-MM-DD')} />
      <LineItem label='Last login on' text={user.last_login_on ? moment(user.last_login_on).format('YYYY-MM-DD') : "Never"} />
    </React.Fragment>
  );
};

UserInfo.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserInfo;



// WEBPACK FOOTER //
// ./webAdmin/components/users/user/info.js